import React, { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import {
    Autocomplete,
    Backdrop,
    Breadcrumbs,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormHelperText,
    IconButton,
    TextField,
    Typography
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import FormControl from "@mui/material/FormControl";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import InputAdornment from "@mui/material/InputAdornment";
import { inputBaseClasses } from "@mui/material/InputBase";
import { Link, useLocation, useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import {
    createInternalMMRfqQuote,
    getPartDetailsQuote,
    uploadFileForQuoteAttachment
} from "../Services/MMRfqForm";
import dayjs from "dayjs";
import { Dayjs } from "dayjs";
import { showToast } from "../../Components/Toast";
import {
    getLoggedInUserDepartment,
    getLoggedInUserGroup,
    getLoggedInUserID
} from "../../Utils/Constant";
import { ThreeDot } from "react-loading-indicators";
import { useBeforeUnloadPrompt } from "../../hooks/useUnsavedChangesPrompt";
import { usePrompt } from "../../hooks/usePrompt";

interface FormValues {
    selectedPartner: { title: string } | null;
    paymentTerms: { title: string } | null;
    incoTerms: { title: string } | null;
    leadTimeSample: string;
    leadTimeProduction: string;
    otherTerms: string;
    quoteValidity: Dayjs | null;
    submissionDate: Dayjs | null;
    rmGrade: string;
    rmWeight: string;
    rmPrice: string;
    finishWeight: string;
    finalRmPrice: string;
    processCost: string;
    ohProfit: string;
    scrapCost: string;
    toolName: string;
    toolPrice: string;
    quantity: string;
    uom: { title: string } | null;
    unitPrice: string;
    leadTimeTool: string;
    paymentTermsTool: { title: string } | null;
}

const UOM = [{ title: "Nos" }, { title: "Kg" }];

const PayTerms = [
    { title: "100% Advance" },
    { title: "50% Advance and balance 50% at the time of delivery" },
    { title: "100% at the time of delivery" },
    { title: "15 days credit" },
    { title: "30 days credit" },
    { title: "45 days credit" },
    { title: "60 days credit" },
    { title: "Others" }
];

const incoTerms = [
    { title: "Ex Works (EXW)" },
    { title: "Free Carrier (FCA)" },
    { title: "Free Alongside Ship (FAS)" },
    { title: "Free On Board (FOB)" },
    { title: "Cost and Freight (CFR)" },
    { title: "Cost, Insurance and Freight (CIF)" },
    { title: "Carriage Paid (CPT)" },
    { title: "Carriage and Insurance Paid (CIP)" },
    { title: "Delivery Duty Paid (DDP)" },
    { title: "Delivered At Place (DAP)" }
];

export const MenualQuotation = () => {
    const [finalRMPrice, setFinalRMPrice] = useState("");
    const [isAssigning, setIsAssigning] = useState(false);
    const [processCost, setProcessCost] = useState("");
    const [scrapCost, setScrapCost] = useState("");
    const [packagingCharges, setPackagingCharges] = useState("");
    const [transportationCost, setTransportationCost] = useState("");
    const [ohProfit, setOhProfit] = useState("");
    const [unitPrice, setUnitPrice] = useState("");
    const [totalPrice, setTotalPrice] = useState("");
    const [quantity, setQuantity] = useState("");
    const [isToolApplicable, setIsToolApplicable] = useState("No");
    const [fileTec, setFileTec] = useState<File | null>(null);
    const [errorTextTec, setErrorTextTec] = useState("");
    const fileInputRefTec = useRef<HTMLInputElement>(null);
    const [errors, setErrors] = React.useState(null);
    const [partnerOptions, setPartnerOptions] = useState([]);
    const [selectedPart, setSelectedPart] = useState(null);
    const [partnerObject, setPartnerObject] = useState([]);
    const [quoteCreatedPartner, setQuoteCreatedPartner] = useState([]);
    const [openRemoveDialog, setOpenRemoveDialog] = useState(false);
    const [errorDialog, setErrorDialog] = useState(false);

    const [isFormTouched, setIsFormTouched] = useState(false);
    // usePrompt("Changes you made may not be saved.", isFormTouched);
    useBeforeUnloadPrompt(isFormTouched, "Changes you made may not be saved.");

    const [openPrompt, setOpenPromt] = useState(false);
    const [formValues, setFormValues] = React.useState<FormValues>({
        selectedPartner: null,
        paymentTerms: null,
        incoTerms: null,
        leadTimeSample: "",
        leadTimeProduction: "",
        otherTerms: "",
        quoteValidity: null,
        submissionDate: dayjs(),
        rmGrade: "",
        rmWeight: "",
        rmPrice: "",
        finishWeight: "",
        finalRmPrice: "",
        processCost: "",
        ohProfit: "",
        scrapCost: "",
        toolName: "",
        toolPrice: "",
        quantity: "",
        uom: null,
        unitPrice: "",
        leadTimeTool: "",
        paymentTermsTool: null
    });
    const handleCloseDialog = () => {
        setOpenRemoveDialog(false);
    };

    const handleClosePromptDialog = () => {
        setOpenPromt(false);
    };
    const handleCloseErrorDialog = () => {
        setErrorDialog(false);
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 100); // Delay in ms (adjust if needed)
    };
    const location = useLocation();
    const navigate = useNavigate();
    const coRFQId = location.state?.rfqData;
    // useEffect(() => {
    //   // const calculateUnitPrice =
    //   // Number(finalRMPrice) +
    //   // Number(processCost) +
    //   // Number(packagingCharges) +
    //   // Number(transportationCost) +
    //   // Number(ohProfit) -
    //   // Number(scrapCost);

    //   const calculateTotalP = Number(unitPrice) * Number(selectedPart?.Qty_Year);

    //   setUnitPrice(calculateTotalP.toFixed(2));
    //   setTotalPrice(calculateTotalP.toFixed(2));
    // }, [
    //   // finalRMPrice,
    //   // packagingCharges,
    //   // processCost,
    //   // transportationCost,
    //   // scrapCost,
    //   // ohProfit,
    //   unitPrice,
    // ]);

    useEffect(() => {
        if (unitPrice && selectedPart?.Qty_Year) {
            const calculateTotal =
                Number(unitPrice) * Number(selectedPart?.Qty_Year);
            setTotalPrice(calculateTotal.toFixed(2));
        } else {
            setTotalPrice("");
        }
    }, [unitPrice, selectedPart?.Qty_Year]);

    const handleFileChangeTec = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        const allowedTypes = [
            "application/pdf",
            "image/png",
            "image/jpeg",
            "image/jpg",
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ];
        if (file) {
            if (!allowedTypes.includes(file.type)) {
                setErrorTextTec(
                    "Only PDF, PNG, JPEG, or JPG files are allowed."
                );
                setFileTec(null);
                return;
            }
            if (file.size > 10 * 1024 * 1024) {
                setErrorTextTec("File size should be less than 10MB.");
                setFileTec(null);
                return;
            }
            if (file) {
                setFileTec(file);
                setErrorTextTec("");
            }
        }
    };

    const handleClearFileTec = () => {
        setFileTec(null);
        setErrorTextTec("");
        if (fileInputRefTec.current) {
            fileInputRefTec.current.value = "";
        }
    };

    const preventDefaultTec = (e: React.DragEvent) => {
        e.preventDefault();
    };

    const handleDropTec = (e: React.DragEvent) => {
        e.preventDefault();
        const file = e.dataTransfer.files?.[0];
        const allowedTypes = [
            "application/pdf",
            "image/png",
            "image/jpeg",
            "image/jpg"
        ];
        if (file) {
            if (!allowedTypes.includes(file.type)) {
                setErrorTextTec(
                    "Only PDF, PNG, JPEG, or JPG files are allowed."
                );
                setFileTec(null);
                return;
            }
            if (file.size > 10 * 1024 * 1024) {
                setErrorTextTec("File size should be less than 10MB.");
                setFileTec(null);
                return;
            }
            if (file) {
                setFileTec(file);
                setErrorTextTec("");
            }
        }
    };

    const validate = () => {
        const requiredFields = [
            "selectedPartner",
            "paymentTerms",
            "incoTerms",
            "leadTimeSample",
            "leadTimeProduction",
            // "quoteValidity",
            // "rmGrade",
            // "rmWeight",
            // "rmPrice",
            // "finishWeight",
            // "finalRmPrice",
            // "processCost",
            // "ohProfit",
            // "scrapCost",
            "unitPrice",
            "submissionDate"
        ];

        if (isToolApplicable === "Yes") {
            requiredFields.push(
                "toolName",
                "toolPrice",
                "quantity",
                "uom",
                "leadTimeTool",
                "paymentTermsTool"
            );
        }

        const newErrors = {};

        requiredFields.forEach((field) => {
            if (!formValues[field]) {
                newErrors[field] = "This field is required";
            }
        });
        if (!fileTec) {
            setErrorTextTec("Attach quote is required");
        } else {
            setErrorTextTec("");
        }

        setErrors(newErrors);
        return Object.keys(newErrors)?.length === 0 && !!fileTec;
    };

    const createQuoteAPI = async () => {
        setIsAssigning(true);
        try {
            const payload = {
                Quote_Details: [
                    {
                        Department: getLoggedInUserDepartment(),
                        Group: getLoggedInUserGroup(),
                        Partner_Name:
                            partnerObject?.find(
                                (item) =>
                                    item?.Legal_Name_of_Business ===
                                    formValues?.selectedPartner?.title
                            )?.ID ?? "",
                        Packing_Charges_Unit_if_Applicable:
                            packagingCharges?.toString() ?? "",
                        RM_Weight: formValues?.rmWeight ?? "",
                        Payment_Terms: formValues?.paymentTerms?.title ?? "",
                        Submission_Date:
                            formValues?.submissionDate?.format("DD-MMM-YYYY") ??
                            "",
                        Lead_time_for_Sample: formValues?.leadTimeSample ?? "",
                        Process_Cost: formValues?.processCost ?? "",
                        Quantity_Year: selectedPart?.Qty_Year ?? "",
                        Part_Name: selectedPart?.Part_Row_ID ?? "",
                        Total_Price: totalPrice?.toString() ?? "",
                        Lead_time_for_Complete_Production:
                            formValues?.leadTimeProduction ?? "",
                        RM_Price_Kg: formValues?.rmPrice ?? "",
                        RM_Grade: formValues?.rmGrade ?? "",
                        Finished_Weight: formValues?.finishWeight ?? "",
                        OH_Profit: formValues?.ohProfit ?? "",
                        Other_terms_conditions: formValues?.otherTerms ?? "",
                        Quote_Validity:
                            formValues?.quoteValidity?.format("DD-MMM-YYYY") ??
                            "",
                        Part_Number: selectedPart?.Part_Row_ID ?? "",
                        Part_ID: selectedPart?.Part_Row_ID ?? "",
                        MM_RFQ_ID: selectedPart?.MM_RFQ_ID ?? "",
                        UOM: selectedPart?.UOM ?? "",
                        Final_RM_Price: formValues?.finalRmPrice ?? "",
                        Scrap_Cost: formValues?.scrapCost ?? "",
                        Incoterms: formValues?.incoTerms?.title ?? "",
                        Transportation_Cost_Unit_if_Applicable:
                            transportationCost?.toString() ?? "",
                        Unit_Price: unitPrice?.toString() ?? "",
                        Is_Tool_Applicable: isToolApplicable ?? "",
                        Enter_Tool_Name: formValues?.toolName ?? "",
                        Tool_Price: formValues?.toolPrice ?? "",
                        Quantity: formValues?.quantity ?? "",
                        Tool_UOM: formValues?.uom?.title ?? "",
                        Lead_time_for_Tool: formValues?.leadTimeTool ?? "",
                        Payment_Terms_Tool:
                            formValues?.paymentTermsTool?.title ?? "",
                        Company_RFQ: coRFQId?.ID ?? "",
                        Actor: getLoggedInUserID() ?? ""
                    }
                ]
            };

            const response = await createInternalMMRfqQuote(payload);

            if (response?.status === true && response?.data?.ID) {
                const uploadResponse = await uploadFileForQuoteAttachment({
                    recordId: response?.data?.ID,
                    uploadField: "Quote_Attachment",
                    fileUpload: fileTec
                });

                if (uploadResponse?.status) {
                    showToast({
                        message: "Quote submitted",
                        type: "success"
                    });
                    navigate("/layout/AllMmrfq", {
                        state: {
                            rfqData: {
                                ID: coRFQId?.ID ?? null,
                                rfqID: coRFQId?.rfqID ?? null,
                                assigneeName: coRFQId?.assigneeName ?? null
                            }
                        }
                    });
                } else {
                    showToast({
                        message: "Attachment upload failed.",
                        type: "error"
                    });
                }
            } else {
                showToast({
                    message: "Failed to create the quote.",
                    type: "error"
                });
            }
        } catch (error) {
            console.error("Error in createQuoteAPI:", error);
            showToast({
                message: "An error occurred. Please try again.",
                type: "error"
            });
        } finally {
            setIsAssigning(false);
        }
    };

    const handleSubmit = async () => {
        if (validate()) {
            setOpenRemoveDialog(true);
        } else {
            setErrorDialog(true);
            console.log("Validation failed", errors);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            const payload = {
                MmRfqId: coRFQId?.mmRfqRowId,
                MmPartID: coRFQId?.Part_Row_ID
            };

            const response = await getPartDetailsQuote(payload);
            if (response?.status && response?.data?.length > 0) {
                const part = response?.data[0];
                setSelectedPart(part);
                const partnerMapped = part?.Select_Partners?.map((partner) => ({
                    title: partner?.Legal_Name_of_Business,
                    partnerID: partner?.Partner_ID
                }));
                setPartnerOptions(partnerMapped);
                setPartnerObject(part?.Select_Partners);
                setQuoteCreatedPartner(part?.Quote_Partners);
            }
        };

        fetchData();
    }, []);
    console.log("......................", coRFQId);
    return (
        <>
            <div>
                <Breadcrumbs
                    aria-label="breadcrumb"
                    sx={{ marginBottom: "10px" }}
                >
                    <Typography sx={{ fontSize: "14px" }}>
                        <Link
                            to="/layout/Dashboard"
                            style={{
                                color: "#0070BA",
                                fontSize: "14px",
                                textDecoration: "none"
                            }}
                        >
                            Home
                        </Link>
                    </Typography>
                    <Typography sx={{ fontSize: "14px" }}>
                        <Link
                            to="/layout/CURFQAssignedToMe"
                            style={{
                                color: "#0070BA",
                                fontSize: "14px",
                                textDecoration: "none"
                            }}
                        >
                            Assigned CORFQ to Me
                        </Link>
                    </Typography>
                    <Typography key="final" sx={{ fontSize: "14px" }}>
                        <Link
                            to="/layout/AllMmrfq"
                            style={{
                                color: "#0070BA",
                                fontSize: "14px",
                                textDecoration: "none"
                            }}
                            state={{
                                rfqData: {
                                    ID: coRFQId?.ID,
                                    rfqID: coRFQId?.rfqID,
                                    assigneeName: coRFQId?.assigneeName
                                }
                            }}
                        >
                            All MMRFQs
                        </Link>
                    </Typography>
                    <Typography key="final" sx={{ fontSize: "14px" }}>
                        {coRFQId?.mmRfqId}
                    </Typography>
                </Breadcrumbs>
                <Typography variant="h5" mb={1}>
                    Partner Quotation Form
                </Typography>
                <Box
                    sx={{
                        borderRadius: "5px",
                        marginTop: "16px",
                        background: "#fff",
                        padding: "15px"
                    }}
                >
                    <Typography variant="subtitle1" mb={1}>
                        Part Name - {selectedPart?.Part_Name}
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 3, xs: 12 }}>
                            <Autocomplete
                                disablePortal
                                options={[...partnerOptions]?.sort((a, b) =>
                                    a?.title?.localeCompare(b?.title)
                                )}
                                getOptionLabel={(option) =>
                                    `${option?.title} (${option?.partnerID})`
                                }
                                fullWidth
                                value={formValues?.selectedPartner}
                                // DISABLE options already in quoteCreatedPartner
                                getOptionDisabled={(option) =>
                                    quoteCreatedPartner?.some(
                                        (p) =>
                                            p?.trim()?.toLowerCase() ===
                                            option?.title?.trim()?.toLowerCase()
                                    )
                                }
                                onChange={(event, newValue) => {
                                    if (!isFormTouched) setIsFormTouched(true);

                                    setFormValues((prev) => ({
                                        ...prev,
                                        selectedPartner: newValue
                                    }));
                                    if (errors?.selectedPartner) {
                                        setErrors((prevErrors) => {
                                            const updatedErrors = {
                                                ...prevErrors
                                            };
                                            delete updatedErrors?.selectedPartner;
                                            return updatedErrors;
                                        });
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={
                                            <>
                                                Partner Name{" "}
                                                <span style={{ color: "red" }}>
                                                    *
                                                </span>
                                            </>
                                        }
                                        error={!!errors?.selectedPartner}
                                        helperText={errors?.selectedPartner}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid size={{ md: 3, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    disabled
                                    sx={{ minWidth: "100%" }}
                                    label="Submission Date"
                                    value={formValues?.submissionDate}
                                    slotProps={{
                                        field: {
                                            readOnly: true
                                        }
                                    }}
                                />
                                {errors?.submissionDate && (
                                    <FormHelperText error sx={{ mt: 1 }}>
                                        {errors?.submissionDate}
                                    </FormHelperText>
                                )}
                            </LocalizationProvider>
                        </Grid>
                        <Grid size={{ md: 3, xs: 12 }}>
                            <TextField
                                fullWidth
                                disabled
                                id="outlined-disabled"
                                label="Part ID"
                                variant="outlined"
                                defaultValue={selectedPart?.Part_ID}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                        <Grid size={{ md: 3, xs: 12 }}>
                            <TextField
                                fullWidth
                                disabled
                                id="outlined-disabled"
                                label="Part Number"
                                variant="outlined"
                                defaultValue={selectedPart?.Part_Number}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                        <Grid size={{ md: 3, xs: 12 }}>
                            <TextField
                                fullWidth
                                disabled
                                id="outlined-disabled"
                                label="Part Name"
                                variant="outlined"
                                defaultValue={selectedPart?.Part_Name}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                    </Grid>
                    <br></br>
                    <Divider />
                    <Typography variant="subtitle1" mb={1} mt={2}>
                        Terms & Conditions
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 3, xs: 12 }}>
                            <Autocomplete
                                disablePortal
                                options={[...PayTerms]?.sort((a, b) =>
                                    a?.title?.localeCompare(b?.title)
                                )}
                                getOptionLabel={(option) => option.title}
                                fullWidth
                                value={formValues?.paymentTerms}
                                onChange={(event, newValue) => {
                                    setFormValues((prev) => ({
                                        ...prev,
                                        paymentTerms: newValue
                                    }));

                                    // Clear error for paymentTerms when newValue is selected
                                    if (errors?.paymentTerms) {
                                        setErrors((prevErrors) => {
                                            const updatedErrors = {
                                                ...prevErrors
                                            };
                                            delete updatedErrors.paymentTerms;
                                            return updatedErrors;
                                        });
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={
                                            <>
                                                Payment Terms{" "}
                                                <span style={{ color: "red" }}>
                                                    *
                                                </span>
                                            </>
                                        }
                                        error={!!errors?.paymentTerms}
                                        helperText={errors?.paymentTerms}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid size={{ md: 3, xs: 12, lg: 3 }}>
                            <Autocomplete
                                disablePortal
                                options={[...incoTerms]?.sort((a, b) =>
                                    a?.title?.localeCompare(b?.title)
                                )}
                                getOptionLabel={(option) => option.title}
                                fullWidth
                                value={formValues?.incoTerms}
                                onChange={(event, newValue) => {
                                    setFormValues((prev) => ({
                                        ...prev,
                                        incoTerms: newValue
                                    }));

                                    // Clear error for paymentTerms when newValue is selected
                                    if (errors?.incoTerms) {
                                        setErrors((prevErrors) => {
                                            const updatedErrors = {
                                                ...prevErrors
                                            };
                                            delete updatedErrors.incoTerms;
                                            return updatedErrors;
                                        });
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={
                                            <>
                                                Inco Terms{" "}
                                                <span style={{ color: "red" }}>
                                                    *
                                                </span>{" "}
                                            </>
                                        }
                                        error={!!errors?.incoTerms}
                                        helperText={errors?.incoTerms}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid size={{ md: 3, xs: 12, lg: 3 }}>
                            <TextField
                                fullWidth
                                id="outlined-suffix-shrink"
                                label={
                                    <>
                                        Lead Time for Sample{" "}
                                        <span style={{ color: "red" }}>*</span>
                                    </>
                                }
                                variant="outlined"
                                value={formValues?.leadTimeSample}
                                onChange={(e) => {
                                    if (!isFormTouched) setIsFormTouched(true);
                                    const value = e.target.value;
                                    const sanitized = value.replace(
                                        /[^a-zA-Z0-9 ]/g,
                                        ""
                                    );

                                    setFormValues((prev) => ({
                                        ...prev,
                                        leadTimeSample: sanitized
                                    }));

                                    if (errors?.leadTimeSample) {
                                        setErrors((prevErrors) => {
                                            const updatedErrors = {
                                                ...prevErrors
                                            };
                                            delete updatedErrors.leadTimeSample;
                                            return updatedErrors;
                                        });
                                    }
                                }}
                                error={!!errors?.leadTimeSample}
                                helperText={
                                    errors?.leadTimeSample ||
                                    "Enter in Days or Weeks"
                                }
                            />
                        </Grid>
                        <Grid size={{ md: 3, xs: 12 }}>
                            <TextField
                                fullWidth
                                id="outlined-suffix-shrink"
                                label={
                                    <>
                                        Lead Time for Production{" "}
                                        <span style={{ color: "red" }}>*</span>{" "}
                                    </>
                                }
                                variant="outlined"
                                value={formValues?.leadTimeProduction}
                                onChange={(e) => {
                                    if (!isFormTouched) setIsFormTouched(true);
                                    const value = e.target.value;
                                    const sanitized = value.replace(
                                        /[^a-zA-Z0-9 ]/g,
                                        ""
                                    );

                                    setFormValues((prev) => ({
                                        ...prev,
                                        leadTimeProduction: sanitized
                                    }));

                                    if (errors?.leadTimeProduction) {
                                        setErrors((prevErrors) => {
                                            const updatedErrors = {
                                                ...prevErrors
                                            };
                                            delete updatedErrors?.leadTimeProduction;
                                            return updatedErrors;
                                        });
                                    }
                                }}
                                error={!!errors?.leadTimeProduction}
                                helperText={
                                    errors?.leadTimeProduction ||
                                    "Enter in Days or Weeks"
                                }
                            />
                        </Grid>
                        <Grid size={{ md: 3, xs: 12 }}>
                            <TextField
                                fullWidth
                                id="outlined-basic"
                                label="Other Terms & Conditions"
                                variant="outlined"
                                value={formValues?.otherTerms}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setFormValues((prev) => ({
                                        ...prev,
                                        otherTerms: value
                                    }));

                                    if (errors?.otherTerms) {
                                        setErrors((prevErrors) => {
                                            const updatedErrors = {
                                                ...prevErrors
                                            };
                                            delete updatedErrors?.otherTerms;
                                            return updatedErrors;
                                        });
                                    }
                                }}
                            />
                        </Grid>
                        <Grid size={{ md: 3, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                {/* <DemoContainer
      components={["DatePicker", "DatePicker"]}
      sx={{ paddingTop: 0 }}
    > */}
                                <DatePicker
                                    sx={{ minWidth: "100%" }}
                                    label={<>Quote Validity</>}
                                    value={formValues?.quoteValidity}
                                    onChange={(newValue) => {
                                        setFormValues((prev) => ({
                                            ...prev,
                                            quoteValidity: newValue
                                        }));
                                        //iferror
                                    }}
                                    minDate={dayjs()}
                                    slotProps={{
                                        field: {
                                            readOnly: true
                                        }
                                    }}
                                />
                                {/* if (errors?.quoteValidity) {
                     setErrors((prevErrors) => {
                       const updatedErrors = { ...prevErrors };
                       delete updatedErrors?.quoteValidity;
                       return updatedErrors;
                     });
                   } */}
                                {/* slotProps={{
                   textField: {
                     error: errors?.quoteValidity,
                   },
                 }} */}
                                {/* {errors?.quoteValidity && (
                  <FormHelperText error sx={{ mt: 1 }}>
                    {errors?.quoteValidity}
                  </FormHelperText>
                )} */}
                                {/* </DemoContainer> */}
                            </LocalizationProvider>
                        </Grid>
                    </Grid>
                    <br></br>
                    <Divider />
                    <Typography variant="subtitle1" mb={1} mt={2}>
                        Price Break Up Details
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 3, xs: 12 }}>
                            <TextField
                                fullWidth
                                id="outlined-"
                                label={<>RM Grade </>}
                                variant="outlined"
                                value={formValues?.rmGrade}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const sanitized = value.replace(
                                        /[^a-zA-Z0-9 ]/g,
                                        ""
                                    );

                                    setFormValues((prev) => ({
                                        ...prev,
                                        rmGrade: sanitized
                                    }));

                                    //iferror
                                }}
                                // if (errors?.rmGrade) {
                                //   setErrors((prevErrors) => {
                                //     const updatedErrors = { ...prevErrors };
                                //     delete updatedErrors?.rmGrade;
                                //     return updatedErrors;
                                //   });
                                // }
                                // error={!!errors?.rmGrade}
                                // helperText={errors?.rmGrade}
                            />
                        </Grid>
                        <Grid size={{ md: 3, xs: 12 }}>
                            <TextField
                                fullWidth
                                id="outlined-required"
                                label={<>RM Weight (Kg)</>}
                                variant="outlined"
                                value={formValues?.rmWeight}
                                type="text"
                                inputProps={{
                                    min: 0,
                                    inputMode: "decimal",
                                    pattern: "^[0-9]*\\.?[0-9]{0,2}$"
                                }}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const regex = /^\d*\.?\d{0,2}$/;
                                    if (value === "" || regex?.test(value)) {
                                        setFormValues((prev) => ({
                                            ...prev,
                                            rmWeight: value
                                        }));
                                        setFormValues((prev) => ({
                                            ...prev,
                                            rmWeight: value
                                        }));

                                        //iferror
                                    }
                                }}
                                //   if (errors?.rmWeight) {
                                //       setErrors((prevErrors) => {
                                //         const updatedErrors = { ...prevErrors };
                                //         delete updatedErrors?.rmWeight;
                                //         return updatedErrors;
                                //       });
                                //     }
                                // error={!!errors?.rmWeight}
                                // helperText={errors?.rmWeight}
                            />
                        </Grid>
                        <Grid size={{ md: 3, xs: 12 }}>
                            <TextField
                                fullWidth
                                id="outlined-required"
                                label={<>RM Price/Kg </>}
                                variant="outlined"
                                type="text"
                                inputProps={{
                                    min: 0,
                                    inputMode: "decimal",
                                    pattern: "^[0-9]*\\.?[0-9]{0,2}$"
                                }}
                                value={formValues?.rmPrice}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const regex = /^\d*\.?\d{0,2}$/;
                                    if (value === "" || regex?.test(value)) {
                                        setFormValues((prev) => ({
                                            ...prev,
                                            rmPrice: value
                                        }));
                                        setFormValues((prev) => ({
                                            ...prev,
                                            rmPrice: value
                                        }));

                                        //iferror
                                    }
                                }}
                                //  if (errors?.rmPrice) {
                                //       setErrors((prevErrors) => {
                                //         const updatedErrors = { ...prevErrors };
                                //         delete updatedErrors?.rmPrice;
                                //         return updatedErrors;
                                //       });
                                //     }
                                // error={!!errors?.rmPrice}
                                // helperText={errors?.rmPrice}
                            />
                        </Grid>
                        <Grid size={{ md: 3, xs: 12 }}>
                            <TextField
                                fullWidth
                                id="outlined-required"
                                label={<>Finished Weight (Kg) </>}
                                variant="outlined"
                                type="text"
                                inputProps={{
                                    min: 0,
                                    inputMode: "decimal",
                                    pattern: "^[0-9]*\\.?[0-9]{0,2}$"
                                }}
                                value={formValues?.finishWeight}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const regex = /^\d*\.?\d{0,2}$/;
                                    if (value === "" || regex?.test(value)) {
                                        setFormValues((prev) => ({
                                            ...prev,
                                            finishWeight: value
                                        }));
                                        setFormValues((prev) => ({
                                            ...prev,
                                            finishWeight: value
                                        }));

                                        //iferror
                                    }
                                }}
                                // if (errors?.finishWeight) {
                                //       setErrors((prevErrors) => {
                                //         const updatedErrors = { ...prevErrors };
                                //         delete updatedErrors?.finishWeight;
                                //         return updatedErrors;
                                //       });
                                //     }
                                // error={!!errors?.finishWeight}
                                // helperText={errors?.finishWeight}
                            />
                        </Grid>
                        <Grid size={{ md: 3, xs: 12 }}>
                            <TextField
                                fullWidth
                                id="outlined-required"
                                label={<>Final RM Price (INR) </>}
                                variant="outlined"
                                type="text"
                                inputProps={{
                                    min: 0,
                                    inputMode: "decimal",
                                    pattern: "^[0-9]*\\.?[0-9]{0,2}$"
                                }}
                                value={formValues?.finalRmPrice}
                                onChange={(e) => {
                                    setFinalRMPrice(e.target.value || "");
                                    const value = e.target.value;
                                    const regex = /^\d*\.?\d{0,2}$/;
                                    if (value === "" || regex?.test(value)) {
                                        setFormValues((prev) => ({
                                            ...prev,
                                            finalRmPrice: value
                                        }));
                                        //iferror
                                    }
                                }}
                                //  if (errors?.finalRmPrice) {
                                //       setErrors((prevErrors) => {
                                //         const updatedErrors = { ...prevErrors };
                                //         delete updatedErrors?.finalRmPrice;
                                //         return updatedErrors;
                                //       });
                                //     }
                                // error={!!errors?.finalRmPrice}
                                // helperText={errors?.finalRmPrice}
                            />
                        </Grid>
                        <Grid size={{ md: 3, xs: 12 }}>
                            <TextField
                                fullWidth
                                id="outlined-required"
                                label={<>Process Cost (INR) </>}
                                variant="outlined"
                                type="text"
                                inputProps={{
                                    min: 0,
                                    inputMode: "decimal",
                                    pattern: "^[0-9]*\\.?[0-9]{0, 2}$"
                                }}
                                value={formValues?.processCost}
                                onChange={(e) => {
                                    setProcessCost(e.target.value || "");
                                    const value = e.target.value;
                                    const regex = /^\d*\.?\d{0,2}$/;
                                    if (value === "" || regex?.test(value)) {
                                        setFormValues((prev) => ({
                                            ...prev,
                                            processCost: value
                                        }));
                                        ///iferror
                                    }
                                }}
                                //  if (errors?.processCost) {
                                //       setErrors((prevErrors) => {
                                //         const updatedErrors = { ...prevErrors };
                                //         delete updatedErrors?.processCost;
                                //         return updatedErrors;
                                //       });
                                //     }
                                // error={!!errors?.processCost}
                                // helperText={errors?.processCost}
                            />
                        </Grid>
                        <Grid size={{ md: 3, xs: 12 }}>
                            <TextField
                                fullWidth
                                id="outlined-required"
                                label={<>OH & Profit (INR) </>}
                                variant="outlined"
                                type="text"
                                inputProps={{
                                    min: 0,
                                    inputMode: "decimal",
                                    pattern: "^[0-9]*\\.?[0-9]{0,2}$"
                                }}
                                value={formValues?.ohProfit}
                                onChange={(e) => {
                                    setOhProfit(e.target.value || "");
                                    const value = e.target.value;
                                    const regex = /^\d*\.?\d{0,2}$/;
                                    if (value === "" || regex?.test(value)) {
                                        setFormValues((prev) => ({
                                            ...prev,
                                            ohProfit: value
                                        }));
                                        //iferror
                                    }
                                }}
                                // if (errors?.ohProfit) {
                                //       setErrors((prevErrors) => {
                                //         const updatedErrors = { ...prevErrors };
                                //         delete updatedErrors?.ohProfit;
                                //         return updatedErrors;
                                //       });
                                //     }
                                // error={!!errors?.ohProfit}
                                // helperText={errors?.ohProfit}
                            />
                        </Grid>
                        <Grid size={{ md: 3, xs: 12 }}>
                            <TextField
                                fullWidth
                                id="outlined-basic"
                                label="Packaging Charges (INR)"
                                variant="outlined"
                                type="text"
                                inputProps={{ inputMode: "decimal" }}
                                value={packagingCharges}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const regex = /^\d*\.?\d{0,2}$/;

                                    if (value === "" || regex.test(value)) {
                                        setPackagingCharges(value);
                                    }
                                }}
                                onKeyDown={(e) => {
                                    if (
                                        ["e", "E", "+", "-", " "].includes(
                                            e.key
                                        )
                                    ) {
                                        e.preventDefault();
                                    }
                                }}
                                onPaste={(e) => {
                                    const paste =
                                        e.clipboardData.getData("text");
                                    if (!/^\d*\.?\d{0,2}$/.test(paste)) {
                                        e.preventDefault();
                                    }
                                }}
                            />
                        </Grid>
                        <Grid size={{ md: 3, xs: 12 }}>
                            <TextField
                                fullWidth
                                id="outlined-basic"
                                label="Transportation Cost (INR)"
                                variant="outlined"
                                type="text"
                                value={transportationCost}
                                inputProps={{ inputMode: "decimal" }}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const regex = /^\d*\.?\d{0,2}$/;

                                    if (value === "" || regex.test(value)) {
                                        setTransportationCost(value);
                                    }
                                }}
                                onKeyDown={(e) => {
                                    if (
                                        ["e", "E", "+", "-", " "].includes(
                                            e.key
                                        )
                                    ) {
                                        e.preventDefault();
                                    }
                                }}
                                onPaste={(e) => {
                                    const paste =
                                        e.clipboardData.getData("text");
                                    if (!/^\d*\.?\d{0,2}$/.test(paste)) {
                                        e.preventDefault();
                                    }
                                }}
                            />
                        </Grid>
                        <Grid size={{ md: 3, xs: 12 }}>
                            <TextField
                                fullWidth
                                id="outlined-required"
                                label={<>Scrap Cost (INR) </>}
                                variant="outlined"
                                type="text"
                                inputProps={{
                                    min: 0,
                                    inputMode: "decimal",
                                    pattern: "^[0-9]*\\.?[0-9]{0, 2}$"
                                }}
                                value={formValues?.scrapCost}
                                onChange={(e) => {
                                    setScrapCost(e.target.value || "");
                                    const value = e.target.value;
                                    const regex = /^\d*\.?\d{0,2}$/;
                                    if (value === "" || regex?.test(value)) {
                                        setFormValues((prev) => ({
                                            ...prev,
                                            scrapCost: value
                                        }));
                                        //iferror
                                    }
                                }}
                                // if (errors?.scrapCost) {
                                //       setErrors((prevErrors) => {
                                //         const updatedErrors = { ...prevErrors };
                                //         delete updatedErrors?.scrapCost;
                                //         return updatedErrors;
                                //       });
                                //     }
                                // error={!!errors?.scrapCost}
                                // helperText={errors?.scrapCost}
                            />
                        </Grid>
                        <Grid size={{ md: 3, xs: 12 }}>
                            <TextField
                                fullWidth
                                id="outlined-disabled"
                                label={
                                    <>
                                        Unit Price (INR){" "}
                                        <span style={{ color: "red" }}>*</span>
                                    </>
                                }
                                variant="outlined"
                                // defaultValue={unitPrice}
                                type="text"
                                value={formValues?.unitPrice}
                                onChange={(e) => {
                                    setUnitPrice(e.target.value || "");
                                    const value = e.target.value;
                                    const regex = /^\d*\.?\d{0,2}$/;
                                    if (value === "" || regex?.test(value)) {
                                        setFormValues((prev) => ({
                                            ...prev,
                                            unitPrice: value
                                        }));
                                        //iferror
                                        if (errors?.unitPrice) {
                                            setErrors((prevErrors) => {
                                                const updatedErrors = {
                                                    ...prevErrors
                                                };
                                                delete updatedErrors?.unitPrice;
                                                return updatedErrors;
                                            });
                                        }
                                    }
                                }}
                                error={!!errors?.unitPrice}
                                helperText={errors?.unitPrice}
                            />
                        </Grid>
                        <Grid size={{ md: 3, xs: 12 }}>
                            <TextField
                                fullWidth
                                id="outlined-disabled"
                                label="Quantity/Year"
                                variant="outlined"
                                type="text"
                                inputProps={{ min: 0 }}
                                value={selectedPart?.Qty_Year}
                                defaultValue={selectedPart?.Qty_Year}
                                onChange={(e) =>
                                    setQuantity(selectedPart?.Qty_Year)
                                }
                                disabled
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                        <Grid size={{ md: 3, xs: 12 }}>
                            <TextField
                                fullWidth
                                disabled
                                id="outlined-required"
                                label="UOM"
                                defaultValue={selectedPart?.UOM}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                        <Grid size={{ md: 3, xs: 12 }}>
                            <TextField
                                fullWidth
                                disabled
                                id="outlined-disabled"
                                label="Total Price (INR)"
                                variant="outlined"
                                type="Number"
                                inputProps={{ min: 0 }}
                                value={totalPrice}
                            />
                        </Grid>
                    </Grid>
                    <br></br>
                    <Divider />
                    <br></br>
                    <FormControl sx={{ marginBottom: "10px" }}>
                        <FormLabel id="demo-radio-buttons-group-label">
                            Is Tool if Applicable?
                        </FormLabel>

                        <RadioGroup
                            row
                            aria-labelledby="demo-radio-buttons-group-label"
                            name="radio-buttons-group"
                            value={isToolApplicable}
                            onChange={(e) => {
                                const value = e.target.value;
                                setIsToolApplicable(value);

                                if (value === "No") {
                                    setErrors((prevErrors) => {
                                        const updatedErrors = { ...prevErrors };
                                        delete updatedErrors.toolName;
                                        delete updatedErrors.toolPrice;
                                        delete updatedErrors.quantity;
                                        delete updatedErrors.uom;
                                        delete updatedErrors.leadTimeTool;
                                        delete updatedErrors.paymentTermsTool;
                                        return updatedErrors;
                                    });
                                }
                            }}
                        >
                            <FormControlLabel
                                value="Yes"
                                control={<Radio />}
                                label="Yes"
                            />
                            <FormControlLabel
                                value="No"
                                control={<Radio />}
                                label="No"
                            />
                        </RadioGroup>
                    </FormControl>
                    {isToolApplicable === "Yes" && (
                        <Grid container spacing={2} mb={2}>
                            <Grid size={{ md: 3, xs: 12 }}>
                                <TextField
                                    fullWidth
                                    id="outlined-basic"
                                    label={
                                        <>
                                            Tool Name{" "}
                                            <span style={{ color: "red" }}>
                                                *
                                            </span>{" "}
                                        </>
                                    }
                                    variant="outlined"
                                    value={formValues?.toolName}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        const sanitized = value.replace(
                                            /[^a-zA-Z0-9 ]/g,
                                            ""
                                        );

                                        setFormValues((prev) => ({
                                            ...prev,
                                            toolName: sanitized
                                        }));

                                        const isValid = /^[A-Za-z\s]*$/.test(
                                            value
                                        );

                                        if (!isValid) {
                                            setErrors((prev) => ({
                                                ...prev
                                            }));
                                        } else {
                                            setErrors((prev) => {
                                                const updatedErrors = {
                                                    ...prev
                                                };
                                                delete updatedErrors?.toolName;
                                                return updatedErrors;
                                            });
                                        }
                                    }}
                                    error={!!errors?.toolName}
                                    helperText={errors?.toolName}
                                />
                            </Grid>

                            <Grid size={{ md: 3, xs: 12 }}>
                                <TextField
                                    fullWidth
                                    id="outlined-basic"
                                    label={
                                        <>
                                            Tool Price (INR){" "}
                                            <span style={{ color: "red" }}>
                                                *
                                            </span>
                                        </>
                                    }
                                    variant="outlined"
                                    type="text"
                                    inputProps={{
                                        min: 0,
                                        inputMode: "decimal",
                                        pattern: "^[0-9]*\\.?[0-9]{0,2}$"
                                    }}
                                    value={formValues?.toolPrice}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        const regex = /^\d*\.?\d{0,2}$/;

                                        if (value === "" || regex.test(value)) {
                                            setFormValues((prev) => ({
                                                ...prev,
                                                toolPrice: value
                                            }));

                                            if (errors?.toolPrice) {
                                                setErrors((prevErrors) => {
                                                    const updatedErrors = {
                                                        ...prevErrors
                                                    };
                                                    delete updatedErrors?.toolPrice;
                                                    return updatedErrors;
                                                });
                                            }
                                        }
                                    }}
                                    error={!!errors?.toolPrice}
                                    helperText={errors?.toolPrice}
                                />
                            </Grid>
                            <Grid size={{ md: 3, xs: 12 }}>
                                <TextField
                                    fullWidth
                                    id="outlined-required"
                                    label={
                                        <>
                                            Quantity{" "}
                                            <span style={{ color: "red" }}>
                                                *
                                            </span>{" "}
                                        </>
                                    }
                                    variant="outlined"
                                    type="text"
                                    inputProps={{
                                        min: 0,
                                        inputMode: "decimal",
                                        pattern: "^[0-9]*\\.?[0-9]{0,2}$"
                                    }}
                                    value={formValues?.quantity}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        const regex = /^\d*\.?\d{0,2}$/;
                                        if (value === "" || regex.test(value)) {
                                            setFormValues((prev) => ({
                                                ...prev,
                                                quantity: value
                                            }));
                                            if (errors?.quantity) {
                                                setErrors((prevErrors) => {
                                                    const updatedErrors = {
                                                        ...prevErrors
                                                    };
                                                    delete updatedErrors?.quantity;
                                                    return updatedErrors;
                                                });
                                            }
                                        }
                                    }}
                                    error={!!errors?.quantity}
                                    helperText={errors?.quantity}
                                />
                            </Grid>
                            <Grid size={{ md: 3, xs: 12 }}>
                                <Autocomplete
                                    fullWidth
                                    disablePortal
                                    options={[...UOM]?.sort((a, b) =>
                                        a?.title?.localeCompare(b?.title)
                                    )}
                                    getOptionLabel={(option) => option.title}
                                    value={formValues.uom}
                                    onChange={(event, newValue) => {
                                        setFormValues((prev) => ({
                                            ...prev,
                                            uom: newValue
                                        }));
                                        // Clear error for paymentTerms when newValue is selected
                                        if (errors?.uom) {
                                            setErrors((prevErrors) => {
                                                const updatedErrors = {
                                                    ...prevErrors
                                                };
                                                delete updatedErrors.uom;
                                                return updatedErrors;
                                            });
                                        }
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            fullWidth
                                            {...params}
                                            label={
                                                <>
                                                    UOM{" "}
                                                    <span
                                                        style={{ color: "red" }}
                                                    >
                                                        *
                                                    </span>{" "}
                                                </>
                                            }
                                            error={!!errors?.uom}
                                            helperText={errors?.uom}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid size={{ md: 3, xs: 12 }}>
                                <TextField
                                    id="outlined-basic"
                                    label={
                                        <>
                                            Lead Time for Tool{" "}
                                            <span style={{ color: "red" }}>
                                                *
                                            </span>
                                        </>
                                    }
                                    fullWidth
                                    variant="outlined"
                                    value={formValues?.leadTimeTool}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        const sanitized = value.replace(
                                            /[^a-zA-Z0-9 ]/g,
                                            ""
                                        );

                                        setFormValues((prev) => ({
                                            ...prev,
                                            leadTimeTool: sanitized
                                        }));
                                        if (errors?.leadTimeTool) {
                                            setErrors((prevErrors) => {
                                                const updatedErrors = {
                                                    ...prevErrors
                                                };
                                                delete updatedErrors?.leadTimeTool;
                                                return updatedErrors;
                                            });
                                        }
                                    }}
                                    error={!!errors?.leadTimeTool}
                                    helperText={
                                        errors?.leadTimeTool ||
                                        "Enter in Days or Weeks"
                                    }
                                />
                            </Grid>
                            <Grid size={{ md: 3, xs: 12 }}>
                                <Autocomplete
                                    disablePortal
                                    options={[...PayTerms]?.sort((a, b) =>
                                        a?.title?.localeCompare(b?.title)
                                    )}
                                    getOptionLabel={(option) => option.title}
                                    fullWidth
                                    value={formValues.paymentTermsTool}
                                    onChange={(event, newValue) => {
                                        setFormValues((prev) => ({
                                            ...prev,
                                            paymentTermsTool: newValue
                                        }));

                                        // Clear error for paymentTerms when newValue is selected
                                        if (errors?.paymentTermsTool) {
                                            setErrors((prevErrors) => {
                                                const updatedErrors = {
                                                    ...prevErrors
                                                };
                                                delete updatedErrors.paymentTermsTool;
                                                return updatedErrors;
                                            });
                                        }
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={
                                                <>
                                                    Payment Terms{" "}
                                                    <span
                                                        style={{ color: "red" }}
                                                    >
                                                        *
                                                    </span>{" "}
                                                </>
                                            }
                                            error={!!errors?.paymentTermsTool}
                                            helperText={
                                                errors?.paymentTermsTool
                                            }
                                        />
                                    )}
                                />
                            </Grid>
                        </Grid>
                    )}

                    <Grid container spacing={2} mb={2}>
                        <Grid size={{ md: 5, xs: 12 }}>
                            <Typography variant="body1" my={1}>
                                Attach Quote{" "}
                                <span style={{ color: "red" }}>*</span>
                            </Typography>

                            <label
                                htmlFor="fileInput"
                                style={{ width: "100%", cursor: "pointer" }}
                            >
                                <Box
                                    sx={{
                                        border: "1px dashed #ccc",
                                        borderRadius: "8px",
                                        textAlign: "center",
                                        padding: "0.5rem 0.5rem 0.7rem",
                                        backgroundColor: "#FAFAFA",
                                        "&:hover": {
                                            borderColor: "#1976D2"
                                        }
                                    }}
                                    onDrop={handleDropTec}
                                    onDragOver={preventDefaultTec}
                                    onDragEnter={preventDefaultTec}
                                >
                                    <CloudUploadIcon
                                        sx={{
                                            fontSize: "2.5rem",
                                            color: "#1976D2"
                                        }}
                                    />
                                    <Typography variant="body1" gutterBottom>
                                        Upload or drag and drop
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                    >
                                        PDF, PNG, JPEG, JPG, XLS, XLSX (max.
                                        10MB)
                                    </Typography>
                                    <input
                                        type="file"
                                        id="fileInput"
                                        style={{ display: "none" }}
                                        ref={fileInputRefTec}
                                        onChange={handleFileChangeTec}
                                        accept=".pdf, .png, .jpeg, .jpg, .xls, .xlsx"
                                    />
                                </Box>
                            </label>

                            {fileTec && (
                                <Box
                                    mt={1}
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        padding: "5px 0px"
                                    }}
                                >
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            overflow: "hidden",
                                            textOverflow: "ellipsis"
                                        }}
                                    >
                                        {fileTec.name}
                                    </Typography>
                                    <IconButton
                                        color="error"
                                        aria-label="Remove file"
                                        onClick={handleClearFileTec}
                                        size="small"
                                    >
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                </Box>
                            )}

                            {errorTextTec && (
                                <FormHelperText error sx={{ mt: 1 }}>
                                    {errorTextTec}
                                </FormHelperText>
                            )}
                        </Grid>
                    </Grid>
                    <Divider />
                    <Grid container spacing={2} justifyContent="end" mt={2}>
                        <Button
                            size="small"
                            variant="outlined"
                            color="error"
                            onClick={() => setOpenPromt(true)}
                        >
                            Cancel
                        </Button>
                        <Button
                            size="small"
                            color="primary"
                            variant="contained"
                            onClick={handleSubmit}
                        >
                            Submit
                        </Button>
                        <Dialog
                            open={openRemoveDialog}
                            onClose={handleCloseDialog}
                        >
                            <DialogTitle fontWeight={"bold"}>
                                Quote Submission
                            </DialogTitle>
                            <DialogContent>
                                <Typography color="text.secondary">
                                    Are you sure you want to submit this Quote?
                                </Typography>
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    onClick={handleCloseDialog}
                                    color="error"
                                >
                                    Cancel
                                </Button>
                                <Button
                                    onClick={createQuoteAPI}
                                    disabled={isAssigning}
                                >
                                    Confirm
                                </Button>
                            </DialogActions>
                        </Dialog>

                        <Dialog
                            open={openPrompt}
                            onClose={handleClosePromptDialog}
                        >
                            {/* <DialogTitle>Remove & Change Team Member ?</DialogTitle> */}
                            <DialogContent>
                                <Typography>
                                    All Unsaved data will be lost. Do you wish
                                    to Proceed?
                                </Typography>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handleClosePromptDialog}>
                                    Cancel
                                </Button>
                                <Button
                                    onClick={() =>
                                        navigate("/layout/AllMmrfq", {
                                            state: {
                                                rfqData: {
                                                    ID: coRFQId?.ID ?? null,
                                                    rfqID:
                                                        coRFQId?.rfqID ?? null,
                                                    assigneeName:
                                                        coRFQId?.assigneeName ??
                                                        null
                                                }
                                            }
                                        })
                                    }
                                    color="error"
                                >
                                    Continue
                                </Button>
                            </DialogActions>
                        </Dialog>

                        <Dialog
                            open={errorDialog}
                            onClose={handleCloseErrorDialog}
                        >
                            <DialogTitle fontWeight={"bold"}>
                                Mandatory Input Required
                            </DialogTitle>
                            <DialogContent>
                                <Typography color="text.secondary">
                                    All Mandatory fields to be filled!
                                </Typography>
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    onClick={handleCloseErrorDialog}
                                    color="error"
                                >
                                    OK
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </Grid>
                </Box>
            </div>
            <Backdrop
                sx={{
                    color: "#fff",
                    zIndex: (theme) => theme.zIndex.modal + 1,
                    backgroundColor: "rgba(0,0,0,0.7)"
                }}
                open={isAssigning}
            >
                <ThreeDot color="#1976d2" size="medium" text="" textColor="" />
            </Backdrop>
        </>
    );
};
